import * as types from './constants';

export const initialState = {
  data: null,
  // null = not checked yet, false = org has no NetworkMerchant (Shopify not connected to the
  // affiliate network), true = connected (data is populated)
  connected: null,
  getLoading: false,
  rateLoading: false,
  lockingWindowLoading: false,
  activationLoading: false,
  errors_api: {}
};

const actions = {
  // Get Network Merchant Status
  [types.GET_NETWORK_MERCHANT_STATUS_REQUEST]: state => ({
    ...state,
    getLoading: true
  }),

  [types.GET_NETWORK_MERCHANT_STATUS_DONE]: (state, { payload }) => ({
    ...state,
    getLoading: false,
    connected: true,
    data: payload
  }),

  [types.GET_NETWORK_MERCHANT_STATUS_NOT_CONNECTED]: state => ({
    ...state,
    getLoading: false,
    connected: false,
    data: null
  }),

  [types.GET_NETWORK_MERCHANT_STATUS_FAILED]: (state, { payload }) => ({
    ...state,
    getLoading: false,
    errors_api: payload
  }),

  // Set Network Merchant Rate
  [types.SET_NETWORK_MERCHANT_RATE_REQUEST]: state => ({
    ...state,
    rateLoading: true
  }),

  [types.SET_NETWORK_MERCHANT_RATE_DONE]: (state, { payload }) => ({
    ...state,
    rateLoading: false,
    data: { ...state.data, ...payload }
  }),

  [types.SET_NETWORK_MERCHANT_RATE_FAILED]: (state, { payload }) => ({
    ...state,
    rateLoading: false,
    errors_api: payload
  }),

  // Set Network Merchant Locking Window
  [types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_REQUEST]: state => ({
    ...state,
    lockingWindowLoading: true
  }),

  [types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_DONE]: (state, { payload }) => ({
    ...state,
    lockingWindowLoading: false,
    data: { ...state.data, ...payload }
  }),

  [types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_FAILED]: (state, { payload }) => ({
    ...state,
    lockingWindowLoading: false,
    errors_api: payload
  }),

  // Request Network Activation
  [types.REQUEST_NETWORK_ACTIVATION_REQUEST]: state => ({
    ...state,
    activationLoading: true
  }),

  [types.REQUEST_NETWORK_ACTIVATION_DONE]: (state, { payload }) => ({
    ...state,
    activationLoading: false,
    data: payload
  }),

  [types.REQUEST_NETWORK_ACTIVATION_FAILED]: (state, { payload }) => ({
    ...state,
    activationLoading: false,
    errors_api: payload
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
